import { render, staticRenderFns } from "./ClippedTab.vue?vue&type=template&id=8b339794&"
import script from "./ClippedTab.vue?vue&type=script&lang=js&"
export * from "./ClippedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports